export default __webpack_public_path__ + "static/media/slide_8.cc34843c.jpg";